<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M17 7v6a2 2 0 002 2h6a2 2 0 002-2V7a2 2 0 00-2-2h-6a2 2 0 00-2 2zm8 6h-6V7h6z"/><path d="M13 9H7a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-6a2 2 0 00-2-2h-6v-6a2 2 0 00-2-2zm0 16H7v-6h6zm8-6v6h-6v-6zM7 17v-6h6v6z"/></svg>